/**
 * HL7 v2 Messaging Configuration Admin Page
 */

import React from 'react';
import { HL7ConfigManager } from '@/components/admin/HL7ConfigManager';
import { PageHeader, PageContainer } from '@/components/weavein';

export default function HL7ConfigPage() {
  return (
    <div className="flex h-full flex-col">
      <PageHeader
        eyebrow="Admin · Integrations"
        title="HL7 Messaging"
        description="Configure HL7 v2 messaging for ADT events and CCD document exchange with LANES LA via MLLP."
      />
      <PageContainer>
        <HL7ConfigManager />
      </PageContainer>
    </div>
  );
}
